import { render, staticRenderFns } from "./MasterSingleSalaryDetails.vue?vue&type=template&id=bf5ab1cc&scoped=true"
import script from "./MasterSingleSalaryDetails.vue?vue&type=script&lang=js"
export * from "./MasterSingleSalaryDetails.vue?vue&type=script&lang=js"
import style0 from "./MasterSingleSalaryDetails.vue?vue&type=style&index=0&id=bf5ab1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5ab1cc",
  null
  
)

export default component.exports